export default __webpack_public_path__ + "074a8b32bffa183dcb423d68f0ef4f46.svg";